import DynamicFormDefinitionResourceModel from '../../generated/types/model/resource/DynamicFormDefinitionResourceModel';

export default class DynamicFormDefinitionResourceViewModel extends DynamicFormDefinitionResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
